module.exports = __webpack_public_path__ + "img/first1.83fe3718.png";